"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initializeInboxRulesEditState_1 = require("./helpers/initializeInboxRulesEditState");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('resetInboxRuleEdit')(function resetInboxRuleEdit(state) {
    var optionState = state.optionState;
    optionState.inboxRulesEditState = initializeInboxRulesEditState_1.default();
}));
//# sourceMappingURL=resetInboxRuleEdit.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/resetInboxRuleEdit.js
// module id = 3410
// module chunks = 2